<style lang="less">
.charge{
	.toidentity{
		color: #032;
	}
	.mdesc{
		border-top: 1px solid rgba(0,0,0,0.1);
		padding: 12px 16px;
		p{
			font-size: 12px;
			color: rgba(0,0,0,0.4);
		}
		span{
			color: #dd2f2f;
			font-weight: 700;
			padding-left: 8px;
		}
	}
	.itembank{
		.vue-item{
			&:before{
				display: none;
			}
		}
	}
}
</style>

<template>
	<!-- Main charge 余额转入 -->
	<section class="charge">

		<toptips :tips="identity.message" v-if="showTopTips">
			<slot v-if="identity.status != 20">
				<router-link  class="toidentity" :to="{name: 'verify', query: {redirect: 'Acctplus_Charge'}}">立即验证</router-link>
			</slot>
		</toptips>

		<div class="form">
			<money
				title="金额"
				:price="order.amt"
				:max="bankInfo.dt"
				placeholder="建议转入 100 元以上的金额"
				v-on:price="setPrice">
			</money>
		</div>
		<div class="mdesc">
			<p>预计每日收益 {{dayIn}} 元</p>
			<p>{{expDate.val}}产生收益，{{expDate.rec}}收益到账<span @click="showDesc">更多</span></p>
		</div>

		<div class="form_space"></div>

		<div class="form">
			<itembank v-on:bankSelect="bankSelect"></itembank>
		</div>

		<div class="form_space"></div>

		<div class="form">
			<div class="tips">{{tips}}</div>
		</div>

		<!-- <agreement :agree="agree" v-on:toggleAgree="toggleAgree">
			<div slot="agree">
				<span>我已阅读并同意</span>
				<router-link to="/text">《用户服务协议》</router-link>
			</div>
		</agreement> -->
		<footbtn btn-txt="下一步" :is-on="isActive" @click.native="next"></footbtn>

	</section>
</template>

<script>
	/*
		global androidJs
		global track
		global Finish
	*/
	import android from '@flyme/jr/js/android.js';
	import poplist from '@flyme/jr/flyme7/component/pop-list/pop-list.vue';
	import footbtn from '@flyme/jr/flyme7/component/foot-btn-simple/foot-btn-simple.vue';
	import agreement from '@flyme/jr/flyme7/component/agreement/agreement.vue';

	import toptips from '../components/toptips.vue';
	// import agreement from '../components/agreement.vue';
	import itembank from '../components/itembank.vue';
	import money from '../components/inputmoney.vue';
	import axios from '../axios.js';
	import apis from '../apis.js';
	import config from '../config.js';

	export default {
		data: function () {
			return {
				tips: '',
				rate: 0,
				agree: true,
				identity: {
					status: 20
				},
				bank: {
					index: -1,
					isShow: false,
					data: []
				},
				order: {
					amt: '',
					order_type: 10,
					bacc_no_i: '',
					bacc_no_l4: '',
					sys_reserved_info: {},
					app_info: ''
				},
				billPayData: {},
				userInfo: {},
				expDate: {
					val: '',
					rec: ''
				},
				bankInfo: {}
			};
		},
		computed: {
			showTopTips: function () {
				if (this.identity.status != 30) {
					return true;
				} else{
					return false;
				}
			},
			isActive: function() {
				if (this.agree && this.order.amt > 0) {
					return this.identity.status == 30 ? true : false;
				}else{
					return false;
				}
			},
			dayIn: function () {
				return Math.floor(this.order.amt *( Math.pow( 1 + (this.rate/100),(1/365) )-1 ) * 100)/100;
			}
		},
		components: {
			itembank,
			poplist,
			toptips,
			footbtn,
			agreement,
			money
		},
		created: function () {
			android('setTitle', {
				title: "转入"
			});
			if (this.$route.query.rate) {
				this.rate = this.$route.query.rate;
			} else {
				this.getRate();
			}
		},
		mounted: function () {
			this.getUserInfo();
			this.getExpDate();
		},
		methods: {
			getRate: function () {
				let _this = this;
				axios.post(apis.acctplus_product_query, {
					show_type: 1
				}).then(function(d) {
					if (d.value) {
						_this.rate = d.value.rate;
					}
				});
			},
			getExpDate: function () {
				let _this = this;
				axios.post(apis.product_expected_date, {}).then(function(d) {
					console.log('product_expected_date', d);
					_this.expDate.val = new Date(parseInt(d.value.value_date)).Format("MM 月 dd 日");
					_this.expDate.rec = new Date(parseInt(d.value.rec_value_date)).Format(" MM 月 dd 日");
				});
			},
			getIdentity: function () {
				let _this = this;
				axios.post(apis.identity_img_query, {
					show_type: 1,
					sys_reserved_info: _this.order.sys_reserved_info
				}).then(function(d) {
					console.log('identity_img_query', d);
					_this.identity = d.value;
				});
			},
			getUserInfo: function () {
				let _this = this;
				android('getUserInfo', {}, function (d) {
					_this.order.sys_reserved_info = JSON.stringify({uid: d.userId});
					_this.getPhonInfo();
					_this.getIdentity();
				});
			},
			getPhonInfo: function () {
				let app_info = {
					sn: androidJs.doAndroidActionSync('getCommonInfoSync', JSON.stringify({key: 'sn'})),
					imei: androidJs.doAndroidActionSync('getCommonInfoSync', JSON.stringify({key: 'imei'})),
					mac: androidJs.doAndroidActionSync('getCommonInfoSync', JSON.stringify({key: 'productModel'})),
					flyme_version: androidJs.doAndroidActionSync('getCommonInfoSync', JSON.stringify({key: 'flymeVersion'})),
					app_version: androidJs.doAndroidActionSync('getCommonInfoSync', JSON.stringify({key: 'app_v'})),
					device_model: androidJs.doAndroidActionSync('getCommonInfoSync', JSON.stringify({key: 'productModel'}))
				};
				this.order.app_info = JSON.stringify(app_info);
			},
			bankSelect: function (d) {
				this.order.bacc_no_i = d.bank_acc_no_index;
				this.order.bacc_no_l4 = d.bank_no_last4;
				this.order.acc_type = d.bank_acc_type;
				this.order.bank_name = d.bank_name;
				this.order.phone = d.phone;
				this.bankInfo = d;
			},
			toggleAgree: function () {
				this.agree = !this.agree;
			},
			setPrice: function (d) {
				this.order.amt = d;
				console.log(this.order);
			},
			next: function () {
				let _this = this;
				if (!this.isActive) {
					return;
				}
				android('showLoadingDialog', {
					mes: '正在加载'
				});
				axios.post(apis.acctplus_order_create, this.order).then(function(d) {
					console.log('acctplus_order_create', d);
					if (d.code != 200) {
						_this.tips = d.message;
						android('hideLoadingDialog');
					}else{
						if (d.value.server_vld_types.indexOf('2') > -1) {
							// 使用支付密码
							_this.prepay(d.value);
						}else {
							android('hideLoadingDialog');
							// _this.$router.replace({path: '/acctplus/codepay', query: {data: JSON.stringify(d.value), app_info: _this.order.app_info, sys_reserved_info: _this.order.sys_reserved_info} });
							android('startPageWithCallback', {
								url: config.staticURL + '/#/acctplus/codepay?data='+ JSON.stringify(d.value) + '&app_info=' + _this.order.app_info + '&sys_reserved_info=' + _this.order.sys_reserved_info,
								start_type:1,
								data:'',
								display:{
									title:'验证手机号'
								}
							}, function (d) {
								if (d.pages == 'Account_result') {
									Finish('Account_result');
								}
							});
						}
					}
				});
			},
			prepay: function (d) {
				let _this = this;
				axios.post(apis.acctplus_order_prepay, {
					order_id: d.order_id,
					vld_type: 2,
					app_info: this.order.app_info
				}).then(function(data) {
					console.log('acctplus_order_prepay', data);
					if (data.code != 200) {
						_this.tips = data.message;
						android('hideLoadingDialog');
					}else{
						let payData = {
							order_id: d.order_id,
							vld_type: 2,
							vld_token: data.value.token,
							vld_req: data.value.vld_req,
							sys_reserved_info: _this.order.sys_reserved_info,
							app_info: _this.order.app_info
						};
						_this.billPayData = payData;
						_this.pwdPay(payData);
					}
				});
			},
			pwdPay: function (prepay) {
				//指纹支付
                let _this = this;

                window.G_chagre_PayPwd_check = _this.paypwd_checked;
                // window.C = _this.changeBanchCard;

				let req_data = {
					req_data_content: prepay.vld_req.pay_pwd_req,
					sign: prepay.vld_req.sign
				};

				console.log('pwdPay', req_data, prepay);

                var d ={
                    validate_scene: "ecash_charge_pwd",
                    json_param: {
                        title: '使用' + _this.order.bank_name + ' 支付 ' + _this.order.amt + ' 元',
                        trade_id: JSON.stringify(req_data),
                        title_mark_text: _this.order.bank_name,
                        // title_mark_color: ""
                        title_click_callback: 'C'
                    }
                };

                console.log(d);

                androidJs.doAndroidAction("requestPwdConfirm", JSON.stringify(d), "G_chagre_PayPwd_check");

			},
			paypwd_checked: function (code, msg, value) {
				let _this = this;
				console.log(code, msg, value);
				if (code === 0) {
					//验证成功
					this.orderpay(value);
				}else if(code === -1){
					android('hideLoadingDialog');
					console.log('cancle 动作，不做处理');
				}else{
					android('hideLoadingDialog');
					// _this.$router.replace({path: '/account/result', query: _this.payData });
					window.G_dialogOk = _this.dialogOk;
					android('showDialog', {
						title: '',
						message: msg,
						okCallBack: 'G_dialogOk'
					});
				}
			},
			dialogOk: function () {
			},
			orderpay: function (data) {
				let _this = this;
				this.billPayData.vld_data = data;
				axios.post(apis.acctplus_order_pay, this.billPayData).then(function(d) {
					console.log('acctplus_order_pay', d);
					if (d.code == 23004) {
						track('event_acctplus_order_pay', {
							way: 'paypwd',
							result: 'faild'
						});
						_this.tips = d.message;
					}else{
						track('event_acctplus_order_pay', {
							way: 'paypwd',
							result: 'success'
						});
						_this.$router.replace({path: '/account/result', query: {pay_order_id: d.value.pay_order_id} });
					}
				});
			},
			showDesc: function () {
				window.G_Acct_charge_desc = this.acct_charge_desc;
				var msg = '1、交易日 15:00 前转入，第二交易日开始计算收益，第三个交易日收益到账\n2、当天15:00 后转入，收益计算顺延一天\n3、如遇节假日，收益计算将顺延';
				android('showDialog', {
					title: '收益规则',
					message: msg,
					okText: '知道了',
					cancelText: '',
					okCallBack: 'G_Acct_charge_desc',
					cancelCallback: '',
					dismissCallback: ''
				});
			},
			acct_charge_desc: function () {

			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Acctplus_charge.vue